export const config = {
    backendApi:"https://api.covalenthq.com/v1/",
    key:'ckey_170bf62322044e829af0f052b6e',
    api:"https://api.covalenthq.com/v1/",
}